import { useParams, useSearchParams } from 'react-router-dom';
import { AgGridEngagementLogs } from 'Components/organisms';
import './styles.scss';
import { BackButton } from 'Components/molecules';

const EngagementLogsPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const sortBy = searchParams.get('sortCol');
  const dir = searchParams.get('dir');

  return (
    <div className="user-notifications-page">
      <div className="user-notifications-page__content">
        <BackButton />
        <AgGridEngagementLogs
          title={`Engagement Logs for ${id ?? '-'}`}
          tableBodyHeight="100%"
          defaultFilter={{ specId: id, sort: { [sortBy || 'updatedAt']: dir?.toUpperCase() as 'ASC' | 'DESC' } }}
        />
      </div>
    </div>
  );
};

export default EngagementLogsPage;
